/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class PolicyRequest extends models.PolicyDescriptionRequest {
    getFixupPrototypeFunction() { return PolicyRequest.fixupPrototype; }

    static newInstance(model: Partial<PolicyRequest>): PolicyRequest {
        let obj = Object.assign(new PolicyRequest(), model);
        PolicyRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<PolicyRequest>): PolicyRequest {
        if (!model) return null;
        return PolicyRequest.newInstance(<PolicyRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: PolicyRequest) {
        if (!obj) return;

        models.PolicyRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: PolicyRequest): boolean {
        if (models.PolicyDescriptionRequest.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, PolicyRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * List of policy IDs to fetch policy details
     */
    policy_ids: Array<string>;

}
